export default __webpack_public_path__ + "static/media/purchase.c7f91ec0.svg";